/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AiStatusBadgeProps } from './AiStatusBadge.props';
import { Badge, BADGE_STATE_SUCCESS, BADGE_TYPE_COMBINATION, BADGE_TYPE_OUTLINE, BadgeProps } from '@squiz/sds';
import { AI_STRINGS } from '../../Constants/Strings.constants';
import React from 'react';

export const AiStatusBadge = ({ ai }: AiStatusBadgeProps): JSX.Element => {
  const badgeProps: BadgeProps = ai.enabled
    ? {
        left: AI_STRINGS.enabled,
        state: BADGE_STATE_SUCCESS,
        type: BADGE_TYPE_COMBINATION,
      }
    : { left: AI_STRINGS.disabled, state: undefined, type: BADGE_TYPE_OUTLINE };

  return <Badge {...badgeProps} />;
};
